import * as THREE from 'three';

// Cuatro direcciones cardinales en el plano XZ. Índice 0 = hacia -Z (de frente a la cámara inicial).
// Sumar 1 al índice = girar a la derecha.
export const DIRS = [
  new THREE.Vector3(0, 0, -1),
  new THREE.Vector3(1, 0, 0),
  new THREE.Vector3(0, 0, 1),
  new THREE.Vector3(-1, 0, 0),
];

/** turn: -1 izquierda, +1 derecha. */
export function turnDir(dirIndex, turn) {
  return (dirIndex + turn + 4) % 4;
}

/** Rotación Y que orienta el -Z local de un objeto hacia DIRS[dirIndex]. */
export function yawOf(dirIndex) {
  return (-dirIndex * Math.PI) / 2;
}

/** Vector "a la derecha" de una dirección horizontal. */
export function rightOf(dir, out = new THREE.Vector3()) {
  return out.set(-dir.z, 0, dir.x);
}
